import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'next-i18next';

import Month from './month';
import {
  DayPickerContainer,
  MonthSelector,
  MonthLabel,
  MonthSelectorLeftArrow,
  MonthSelectorRightArrow,
  TableRangeMonths,
  TableRangeMonth,
  MonthPrice
} from './styles';
import { ArrowIcon } from '@spa/shared/svg';
import { useMonths } from '@spa/shared/hooks/dateRange';
import { formatMoney, monthLabelToNumber } from '@spa/shared/utils';
import { theme } from '@spa/shared/theme';

export const MoveInOutPicker = ({ dateRange, rents = [] }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation();

  const { activeMonths, isPresentActiveMonth, firstDayOfWeek, goToPreviousMonths, goToNextMonths } = dateRange;

  const hoverHandlers = useState(null);
  const months = useMonths(activeMonths, firstDayOfWeek);

  return (
    <DayPickerContainer>
      <MonthSelector>
        <MonthSelectorLeftArrow onClick={goToPreviousMonths} className={isPresentActiveMonth && 'disabled'}>
          <ArrowIcon color={theme.colors.blueDianne} />
        </MonthSelectorLeftArrow>
        {months.map(({ monthLabel, year }) => {
          const monthNumber = monthLabelToNumber(monthLabel, language);
          const rent = rents[monthNumber];

          return (
            <MonthLabel key={`${monthLabel}-${year}`}>
              <span>
                {monthLabel} <span>{year}</span>
              </span>
              {rent ? (
                <MonthPrice>
                  {formatMoney(rent.amount, rent.currency_code)}/{t('month')}
                </MonthPrice>
              ) : null}
            </MonthLabel>
          );
        })}
        <MonthSelectorRightArrow onClick={goToNextMonths}>
          <ArrowIcon color={theme.colors.blueDianne} />
        </MonthSelectorRightArrow>
      </MonthSelector>
      <TableRangeMonths>
        {activeMonths.map(month => (
          <TableRangeMonth key={`${month.year}-${month.month}`}>
            <Month year={month.year} month={month.month} dateRange={dateRange} hoverHandlers={hoverHandlers} />
          </TableRangeMonth>
        ))}
      </TableRangeMonths>
    </DayPickerContainer>
  );
};

MoveInOutPicker.propTypes = {
  dateRange: PropTypes.object.isRequired,
  rents: PropTypes.array
};

export default MoveInOutPicker;
